import { ref, onMounted, onUnmounted } from 'vue'

const HEARTBEAT_KEY = 'cui-fullscreen-notes-heartbeat'
const HEARTBEAT_INTERVAL = 5000 // ms
const HEARTBEAT_THRESHOLD = 7000 // ms
const CHECK_INTERVAL = 1000 // ms
const isSomeTabFullscreen = ref(false)

function sendHeartbeat(fullscreen: boolean) {
  const heartbeat = {
    timestamp: Date.now(),
    fullscreen: fullscreen,
  }
  localStorage.setItem(HEARTBEAT_KEY, JSON.stringify(heartbeat))
}

function clearHeartbeat() {
  localStorage.removeItem(HEARTBEAT_KEY)
}

function checkIfSomeTabIsFullscreen() {
  const heartbeat = localStorage.getItem(HEARTBEAT_KEY)
  if (heartbeat) {
    const { timestamp, fullscreen } = JSON.parse(heartbeat)
    const currentTime = Date.now()
    isSomeTabFullscreen.value = fullscreen && currentTime - timestamp < HEARTBEAT_THRESHOLD
  } else {
    isSomeTabFullscreen.value = false
  }
}

export default function useFullscreenNotesHeartbeat(componentIsFullscreen: boolean) {
  let heartbeatInterval: number | undefined

  function handleTabClose() {
    if (componentIsFullscreen) clearHeartbeat()
  }

  function startChecking() {
    heartbeatInterval = window.setInterval(checkIfSomeTabIsFullscreen, CHECK_INTERVAL)
  }

  function stopChecking() {
    if (heartbeatInterval) {
      clearInterval(heartbeatInterval)
      heartbeatInterval = undefined
    }
  }
  const checkOnStorageChange = (event: StorageEvent) => {
    if (event.key === HEARTBEAT_KEY) {
      checkIfSomeTabIsFullscreen()
    }
  }

  onMounted(() => {
    window.addEventListener('storage', checkOnStorageChange)
    if (componentIsFullscreen) {
      window.addEventListener('beforeunload', handleTabClose)
      // Send initial heartbeat and start interval to keep sending it
      sendHeartbeat(true)
      heartbeatInterval = window.setInterval(() => sendHeartbeat(true), HEARTBEAT_INTERVAL)
    } else {
      // Start checking if another tab is in fullscreen mode
      startChecking()
    }
  })

  onUnmounted(() => {
    stopChecking()
    if (componentIsFullscreen) {
      window.removeEventListener('beforeunload', handleTabClose)
      clearHeartbeat()
    }
    window.removeEventListener('storage', checkOnStorageChange)
  })

  return {
    isSomeTabFullscreen,
  }
}
